module.exports = __webpack_public_path__ + "static/media/arrow.77bf6783.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/arrow.svg
// module id = 1781
// module chunks = 0